module.exports = __webpack_public_path__ + "img/b.7f26b7d1.jpg";